module.exports = __webpack_public_path__ + "static/knittedheartmain-608b80f69434992e814a4a10f4d11965.jpeg";